/** PURE_IMPORTS_START ._IfObservable PURE_IMPORTS_END */
import { IfObservable } from './IfObservable';
export var _if = IfObservable.create;
//# sourceMappingURL=if.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/_esm5/observable/if.js
// module id = ./node_modules/rxjs/_esm5/observable/if.js
// module chunks = vendor